import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const CURRENCIES = [
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$' },
  { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$' },
  { code: 'SEK', name: 'Swedish Krona', symbol: 'kr' },
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr' },
  { code: 'MXN', name: 'Mexican Peso', symbol: 'Mex$' },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$' },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R' },
  { code: 'TRY', name: 'Turkish Lira', symbol: '₺' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ' },
  { code: 'SAR', name: 'Saudi Riyal', symbol: 'ر.س' },
];

/**
 * Currency dropdown selector
 * @param {string} value - Selected currency code
 * @param {function} onChange - Callback with selected currency code
 * @param {string} placeholder - Placeholder text
 */
export default function CurrencySelect({ 
  value, 
  onChange, 
  placeholder = 'Select currency' 
}) {
  const [open, setOpen] = useState(false);
  
  const selected = CURRENCIES.find((c) => c.code === value);
  const label = selected 
    ? `${selected.code} — ${selected.name} (${selected.symbol})` 
    : placeholder;

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full text-left px-4 py-2 bg-[var(--bg-tertiary)] border border-[var(--border-color)] rounded-lg text-xs flex items-center justify-between gap-2 truncate hover:border-[var(--accent-primary)] transition-smooth"
      >
        <span className="truncate text-[var(--text-primary)]">{label}</span>
        <ChevronDown 
          className={`w-3.5 h-3.5 shrink-0 text-[var(--text-tertiary)] transition-transform ${
            open ? 'rotate-180' : ''
          }`} 
        />
      </button>

      {open && (
        <div className="absolute z-30 mt-1 w-full bg-[var(--bg-primary)] border border-[var(--border-color)] rounded-lg shadow-lg max-h-48 overflow-y-auto">
          {CURRENCIES.map((c) => (
            <button
              key={c.code}
              type="button"
              onClick={() => {
                onChange(c.code);
                setOpen(false);
              }}
              className={`w-full text-left px-3 py-1.5 text-xs flex items-center justify-between hover:bg-[var(--bg-secondary)] transition-smooth ${
                value === c.code 
                  ? 'bg-[var(--accent-primary)]/10 text-[var(--accent-primary)] font-medium' 
                  : 'text-[var(--text-primary)]'
              }`}
            >
              <span>{c.code} — {c.name}</span>
              <span className="text-[var(--text-tertiary)]">{c.symbol}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}